import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import { environment } from '../../../environments/environment'

export interface NbCoachReport {
  id: number
  name: string
  monthlytime: number
  mixes_selected: number
  genres_selected: number
  stations_selected: number
  djs_selected: number
  workouts_completed: number
}

export interface NbCoachResponse {
  success: boolean
  coachs: NbCoachReport[]
}


@Injectable()
export class CoachService {
  private API_ENDPOINT = `${environment.HOST}/adminapi/report/`

  constructor(private http: HttpClient) {}

  public getReport(month: number, year: number): Observable<NbCoachResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}coach/sort/name/month/${month}/year/${year}`)
      .map(res => res as NbCoachResponse)
  }
}



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@core/data/coach.service.ts